<template>
  <div>
    <div>index</div>
    <router-link to="/detail">detail</router-link>
  </div>
</template>

<script>
export default {
  name: "Index"
};
</script>
